const stylesTableLightMode = {
    title: {
        color: '#A23C41',
        borderBottom: '4px solid #646354'
    },
    header: {
        textAlign: 'left',
        padding: '8px',
        // backgroundColor: '#f4f4f4',
        backgroundColor: '#646354',
        border: '1px solid #ddd',
        // color: '#000',
        color: 'white',
    },
    cell: {
        padding: '8px',
        border: '1px solid #ddd',
        color: '#000',
    },
    expandedEvenCell: {
        padding: '8px',
        border: '1px solid #ddd',
        color: '#000',
        backgroundColor: '#fff'
    },
    expandedOddCell: {
        padding: '8px',
        border: '1px solid #ddd',
        color: '#000',
        backgroundColor: '#e9e9e9'
    },
    evenRow: {
        backgroundColor: '#fff',
    },
    oddRow: {
        backgroundColor: '#e9e9e9',
    },
    buttonAgregar: {
        width: '25%',
        backgroundColor: '#A42339',
        color: 'white',
        border: 'none',
        padding: 10,
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: 16,
        fontWeight: 'bold',
        borderRadius: 5,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    },
    buttonHoverAgregar: {
        backgroundColor: '#972035'
    },
    buttonHoverCancelar: {
        backgroundColor: '#969696'
    },
    button: {
        width: '75%',
        // backgroundColor: '#A42339',
        backgroundColor: '#0d6efd',
        color: 'white',
        border: 'none',
        padding: 10,
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: 16,
        fontWeight: 'bold',
        borderRadius: 5,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    },
    buttonHover: {
        // backgroundColor: '#972035'
        backgroundColor: '#0a58ca'
    },
    divider: {
        height: '1px',
        backgroundColor: '#ccc',
        marginTop: 10,
        marginBottom: 10,
        width: '100%'
    },
    logoutButtonUpRight: {
        position: "absolute",
        top: "15px",
        right: "120px",
        backgroundColor: "#A23C41",
        color: "#fff",
        border: "none",
        padding: "10px 20px",
        fontSize: "16px",
        fontWeight: "bold",
        borderRadius: "5px",
        cursor: "pointer",
        transition: "background 0.3s",
    }, 
    logoutButton: {
        top: "15px",
        right: "120px",
        backgroundColor: "#A23C41",
        color: "#fff",
        border: "none",
        padding: "10px 20px",
        fontSize: "20px",
        fontWeight: "bold",
        borderRadius: "5px",
        cursor: "pointer",
        transition: "background 0.3s",
    }, 
    logoutButtonHover: {
        backgroundColor: "#972034",
    },
    modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
    },
    modalContent: {
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
        textAlign: "center",
        minWidth: "300px",
        textAlign: 'left',
        zIndex: 1001,
    },
    modalSaveButton: {
        marginTop: "10px",
        padding: "8px 15px",
        backgroundColor: "#A23C41",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: 20,
        fontWeight: 'bold',
        width: '40%'
    },
    modalCloseButton: {
        marginTop: "10px",
        padding: "8px 15px",
        backgroundColor: "#cccccc",
        color: "#A23C41",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: 20,
        fontWeight: 'bold',
        width: '40%',
    },
    separator: {
        width: '100%',
        height: '3px',
        backgroundColor: "#646354",
        marginBottom: 10
    },
    inputContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 10,
        fontSize: 18,
        backgroundColor: '#f8f9fa',
        padding: 10,
        borderRadius: 8,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    },
    label: {
        fontWeight: 'bold',
        color: '#333',
        minWidth: 150,
    },
    input: {
        flex: 1,
        padding: 8,
        fontSize: 16,
        border: '1px solid #ccc',
        borderRadius: 5,
        outline: 'none',
        transition: 'border 0.3s ease-in-out',
    },
    inputFocus: {
        border: '1px solid #0F6EFD',
    },
    expandedEvenRow: {
        backgroundColor: "#fff",
        padding: "10px",
        textAlign: "center",
        border: '1px solid #ddd'
    },    
    expandedOddRow: {
        backgroundColor: "#e9e9e9",
        padding: "10px",
        textAlign: "center",
        border: '1px solid #ddd'
    }, 
    tituloCategoria: {
        fontSize: 24
    },
    buttonEditar: {
        width: '25%',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        padding: 10,
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: 16,
        fontWeight: 'bold',
        borderRadius: 5,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    },    
    editButton: {
        backgroundColor: "#007bff",
        color: "white",
    },
    editButtonHover: {
        backgroundColor: "#0056b3",
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#F3F3F4'
    },
    card: {
        marginTop: 50,
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        width: '40%',
        textAlign: 'center'
    },
    loginTitle: {
        fontSize: '22px',
        fontWeight: 'bold',
        color: '#A23C41',
        marginBottom: '20px'
    },
    loginLabel: {
        display: 'block',
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '5px'
    },    
    footerText: {
        marginTop: '15px',
        fontSize: '14px',
        color: '#666'
    },
    buttonVerificar: {
        backgroundColor: '#17a2b8',
        width: '25%',
        color: 'white',
        border: 'none',
        padding: 10,
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: 16,
        fontWeight: 'bold',
        borderRadius: 5,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',        
    },
    verificarButtonHover: {
        backgroundColor: "#138496",
    },
}

export default stylesTableLightMode;